import PropTypes from 'prop-types'

const InsertNewHeader = ({ title }) => {
    return (
        <header className='header'>
            <h1>{title}</h1>
        </header>
    )
}

InsertNewHeader.defaultProps = {
    title: 'Insert Worker Performance Grading',
}

InsertNewHeader.propTypes = {
    title: PropTypes.string.isRequired,
}

export default InsertNewHeader
